module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Site Page Favorities */

(function(fox) {
	
	fox.registerWidget('SitePage_Favorites', {
		activate: function() {
			this.callParent('activate', arguments);
			this.requireEmbeddedWidget('favorites').dl.load();
		}
	}, 'Site_Page');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/sitepage/favorites.js
// module id = 897
// module chunks = 4